import React from 'react';

// import { DetailsChildrenTab } from 'app/main/components/page-layouts';
import { type DetailsPageProps } from 'app/main/components/page-layouts/details/DetailsPage';

import ErpQuotationsDetailsTab from './tabs/ErpQuotationsDetailsTab';
import ErpQuotationsLinesTab from './tabs/ErpQuotationsLinesTab';

export default [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <ErpQuotationsDetailsTab {...props} />
	},
	{
		id: 'lines',
		title: 'MODULE_ERP_QUOTATIONS_LINES_NAME',
		disabled: ({ isEdit }) => isEdit,
		content: ({ model, refresh, updateRefresh }) => (
			<ErpQuotationsLinesTab quotationErpId={model.quot_erp_id} refresh={refresh} updateRefresh={updateRefresh} />
		)
	}
] as DetailsPageProps['tabs'];
